var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSquareGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74965 11.0277L13.4161 10.9723",
    stroke: "#6A6077",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1106 14.3332L10.0551 7.66678",
    stroke: "#6A6077",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65229 19.3538L12.6521 19.3122C16.8186 19.2776 18.4714 17.5971 18.4367 13.4306L18.3951 8.43074C18.3604 4.26422 16.68 2.61148 12.5134 2.64615L7.51361 2.68776C3.34709 2.72243 1.69435 4.40291 1.72902 8.56943L1.77062 13.5693C1.80529 17.7358 3.48577 19.3885 7.65229 19.3538Z",
    stroke: "#6A6077",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSquareGrey);
export default __webpack_public_path__ + "static/media/add-square-grey.5a753ad124d53ef7f11e526694296aba.svg";
export { ForwardRef as ReactComponent };